import { Component, Input, OnInit } from "@angular/core";

import { SharedService } from "@shared/services/shared.service";
import { IAdministrativeComplaintView, IComplaintView } from "app/models/mainMenu/mainMenu";

import { AdminService } from "app/services/admin/admin.service";
import { BusinessService } from "app/services/business/business.service";
import { ComplaintService } from "app/services/complaint/complaint.service";
import { Subscription } from "rxjs";


@Component({
  selector: 'complaint-complaintDetails',
  styleUrls: ['./complaintDetails.component.scss'],
  templateUrl: './complaintDetails.component.html'
})

export class ComplaintDetailsComponent implements OnInit {

  @Input() complaintId: string = '';

  complaintSubscription: Subscription;
  currentComplaint: IAdministrativeComplaintView = {} as IAdministrativeComplaintView;
  initialComplaint: IComplaintView = {} as IComplaintView;

  constructor(
    public complaintService: ComplaintService,
    public businessService: BusinessService,
    private sharedService: SharedService,
    private adminService: AdminService,
  ) {

  }

  ngOnInit(): void {
    this.complaintSubscription = this.complaintService.updateEvent.subscribe((data: number) => {
      if (data == 0) {
        this.init();
      }
    });
  }
  
  ngOnDestroy() {
    this.complaintSubscription.unsubscribe();
  }
 
  init() {
    this.currentComplaint = this.complaintService.currentComplaint;
    this.initialComplaint = this.currentComplaint.initialComplaint;
  }
  

  getComplaint() {
    this.complaintService.getComplaint(this.complaintService.complaintId).subscribe(
      (result) => {
        this.currentComplaint = result;
        this.initialComplaint = this.currentComplaint.initialComplaint;
      },
      error => {
        this.sharedService.toastr.error("Could not get Complaint Data:" + error.message);
      }
    );
  }

  businessType(typeId: string): string {
    return this.sharedService.getBusinessType(typeId);
  }

  gotoEdit() {
    this.complaintService.complaintId = this.complaintService.complaintId;
    this.adminService.complaintId = this.complaintService.complaintId;
    this.adminService.complaintSearch = this.complaintService.complaintId.toString();
    this.sharedService.doRedirect('admin/complaintAdmin');
  }

  refresh() {
    this.getComplaint();
  }

}